import React, { useMemo } from "react";
import "./style.scss";
import Image1 from "../../../assets/images/hotal-1.png";
import { getCurrencyBadge, getListingItemFilters } from "../../../helpers/common";
import BadgeIcon from "../../../assets/images/icons/aroplane-bed.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import { faMapMarkerAlt, faStar } from "@fortawesome/pro-solid-svg-icons";
import { useNavigate } from "react-router";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const ListViewHotelItem = ({ offer, isMobile, hotelId, handleOnView, isChatOffer }) => {
    const { T } = useTranslationCustom();
    const navigate = useNavigate();
    const filters = getListingItemFilters(offer, T, offer?.objHotel?.newPackagedOffer?.flightOffer);

    const isSelected = useMemo(() => String(offer?.id) === String(hotelId), [offer?.id, hotelId]);
    const selectedClass = isSelected ? 'card-selected' : '';

    return (
        <div className={`packages-card-grid ${selectedClass}`} onClick={() => {
            if (isSelected) return;

            navigate(`/hotel/${offer?.id}/map/${isChatOffer ? 'chatOffer' : 'normal'}`, {
                replace: true,
                state: { isChatOffer }
            });
        }}>
            <div className="tick-selected">
                <FontAwesomeIcon icon={faCheck} />
            </div>
            <div className="packages-card-header">
                <img
                    src={offer?.thumbnailUrl || Image1}
                    className="covered-image"
                    alt={"covered-icon"}
                />
                <div className="card-badge">
                    <img src={BadgeIcon} alt={"badge-icon"} />
                    <span>{T("Home:Home_Hotel_Incl_Flight")}</span>
                </div>
            </div>
            <div className="card-middle-area">
                <div className="packages-card-Body">
                    <div>
                        <h4 className="heading heading-6 dark-text font-poppings ellipis">
                            {offer?.name}
                        </h4>
                        <div className="reviews">
                            <div className="star">
                                {[1, 2, 3, 4, 5].map((item, index) => {
                                    if (item <= Number(offer?.starRating))
                                        return (
                                            <FontAwesomeIcon
                                                key={index}
                                                icon={faStar}
                                                className="filled"
                                            />
                                        );
                                    else
                                        return (
                                            <FontAwesomeIcon
                                                key={index}
                                                icon={faStar}
                                                className="blank"
                                            />
                                        );
                                })}
                                <span>
                                    {`${offer?.guestRating || 0} (${offer?.guestReviewCount || 0
                                        })`}
                                </span>
                            </div>
                        </div>
                        <p className="location">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                            {offer?.address}
                        </p>
                        {!isMobile && <ul className="info-tags">
                            {filters?.map((filter, index) => {
                                return (
                                    <li
                                        className="veryLight-bg fs-12 medium darkgray-color"
                                        key={index}
                                    >
                                        {filter.title}
                                    </li>
                                );
                            })}
                        </ul>}
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="price-card">
                            {getCurrencyBadge(offer?.perPersonPrice?.currency)}
                            {Number(offer?.perPersonPrice?.totalPrice).toFixed(0)}
                            <span>p.p</span>
                        </div>

                        {isSelected && <div className={"selected-btn"} onClick={(e) => {
                            e.stopPropagation();
                            handleOnView();
                        }}>
                            {T("Buttons:View")}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

ListViewHotelItem.propTypes = {
    offer: PropTypes.object,
    isMobile: PropTypes.bool,
    hotelId: PropTypes.string,
    handleOnView: PropTypes.func,
    isChatOffer: PropTypes.bool
};

export default ListViewHotelItem;
